const reducer = (state, props) => {
    const { type, payload } = props || {};
    switch (type) {
        case 'SET_STATE_DATA':
            return {
                ...state,
                ...payload,
            }

        case 'CLEAR_STATE':
            return {}

        case "LOADING":
            return {
                ...state,
                loading: true
            }
        case "LOADED":
            return {
                ...state,
                loading: false,
                message: payload
            }

        case 'LOAD_FAILED':
            return {
                ...state,
                loading: false,
                message: payload,
            }
        case 'SET_MENU':
            return {
                ...state,
                menu: {

                    ...(state.menu || {}),
                    ...payload.part
                }
            }
        case "SET_FILTER_PART":
            return {
                ...state,
                filters: { ...state.filters, ...payload.part },
            }

        case "CLEAR_FILTER":
            return {
                ...state,
                filters: {},
                searchResult: undefined,
            }

        case 'SET_FIELD':
            return {
                ...state,
                [payload.name || 'ERROR_IN_FIELD_NAME']: {
                    ...(state[payload.name || 'ERROR_IN_FIELD_NAME'] || {}),
                    ...payload.part
                }
            }
        default:
            return state;

    }
}
export default reducer;
